export default "__VITE_ASSET__D7knm2$6__"